import { Action, createReducer, on } from '@ngrx/store';
import { ILoginState } from './login';
import {
  CAMBIO_PASSWORD_SUCCESS,
  LOGIN_RESET,
  LOGIN_SUCCESS,
  SET_COD_TIPOLOGIA_CP,
} from './login.actions';
import { IResponseCambioPassword } from '../../interfaces/change-password';
import { CodeTipologiaCPEnum } from '../../enum/cod-tipologia-cp.enum';

/* INITIAL STATE */
const initialState: ILoginState = {
  authToken: '',
  responseCambioPassword: null,
};

const handleLogin = (
  state: ILoginState,
  { responseLogin }: { responseLogin: ILoginState }
): ILoginState => {
  return {
    ...state,
    ...responseLogin,
  };
};

const handleChangePassword = (
  state: ILoginState,
  {
    responseCambioPassword,
  }: { responseCambioPassword: IResponseCambioPassword | null }
): ILoginState => {
  return {
    ...state,
    responseCambioPassword,
  };
};

const handleSetTipologiaCp = (
  state: ILoginState,
  { codTipologiaCp }: { codTipologiaCp: CodeTipologiaCPEnum | undefined }
): ILoginState => {
  return {
    ...state,
    ...(state.utente
      ? {
          utente: {
            ...state.utente,
            codTipologiaCp,
          },
        }
      : {}),
  };
};

const handleLoginReset = (): ILoginState => {
  return {
    authToken: '',
    responseCambioPassword: null,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(LOGIN_SUCCESS, handleLogin),
  on(LOGIN_RESET, handleLoginReset),
  on(CAMBIO_PASSWORD_SUCCESS, handleChangePassword),
  on(SET_COD_TIPOLOGIA_CP, handleSetTipologiaCp)
);

export const loginReducer = (
  state: ILoginState | undefined,
  action: Action
): ILoginState => reducer(state, action);
